import React from "react";
import { doctosimg1 } from "../Constant/Index";
import { Link } from "react-router-dom";

const AreYouDoctorSection = ({ getapi }) => {
  const benefits = [
    "Create your profile and get instant appointments",
    "Setup your online practice clinic",
    "Establish online word of mouth",
    "Manage your schedule efficiently",
  ];
  return (
    <section className="are-you-doctor-sec dark-bg mt-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-10 mx-auto">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <figure>
                  <img
                    src={getapi?.sectionThree?.image}
                    className="img-fluid"
                    alt=""
                  />
                </figure>
              </div>
              <div className="col-lg-6">
                <h2 className="main-heading-font dark-color text-white level-2 wow animate__animated animate__zoomIn">
                  {/* Are you a doctor? */}
                  {getapi?.sectionThree?.heading}
                </h2>
                <div className="pb-4">
                  <p className="primary-regular-font extra-color-5 text-white level-7">
                    {/* Join a network of certified doctors and specialists. */}
                    {getapi?.sectionThree?.note}
                  </p>
                </div>
                <Link
                  to="/sign-in"
                  className="btn log-in level-7 mt-4 primary-regular-font text-decoration-none"
                >
                  <span className="bg-wrapper">Join now</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AreYouDoctorSection;
